<div class="flex items-center justify-between gap-4">
  <div class="flex-1">
    <span class="text-sm leading-6" [innerHTML]="data.message"></span>

    @if (data.debugEventId) {
      <div class="text-xs leading-7 text-smoke-dark mt-1">Error ID: {{ data.debugEventId }}</div>
    }
  </div>

  <sbnb-button size="mini" [label]="data.action" (click)="dismiss()" />
</div>
